export default {
  setPartner(state, partner) {
    state.partner = partner;
  },
  setPartners(state, partners) {
    state.partners = partners;
  },
  setUnvaluedPartners(state, partners) {
    state.unvaluedPartners = partners;
  },
};
